import api from '../../../utils/api';

// Service for parcel info requests (backend first; no external Regrid call yet)
export const parcelService = {
  async requestParcelInfo(parcel) {
    const { parcelId, properties, geometry } = parcel || {};
    const body = {
      parcel_id: parcelId || null,
      tile_properties: properties || {},
      geometry_bbox: (() => {
        try {
          if (!geometry || !geometry.coordinates) return null;
          // Compute bbox for Polygon/MultiPolygon
          const coords = Array.isArray(geometry.coordinates) ? geometry.coordinates : [];
          let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
          const walk = (arr) => {
            for (const item of arr) {
              if (Array.isArray(item) && typeof item[0] === 'number' && typeof item[1] === 'number') {
                const x = item[0], y = item[1];
                if (x < minX) minX = x; if (y < minY) minY = y;
                if (x > maxX) maxX = x; if (y > maxY) maxY = y;
              } else if (Array.isArray(item)) {
                walk(item);
              }
            }
          };
          walk(coords);
          if (minX === Infinity) return null;
          return [minX, minY, maxX, maxY];
        } catch (_) { return null; }
      })(),
      path: (properties && properties.path) || ''
    };
    const res = await api.post('/parcel-requests/', body);
    return res.data;
  },
  async listParcelRequests() {
    const res = await api.get('/parcel-requests/');
    // DRF may return results or a list directly
    return Array.isArray(res?.data?.results) ? res.data.results : (res?.data || []);
  },
  async getParcelRequest(id) {
    const res = await api.get(`/parcel-requests/${id}/`);
    return res.data;
  }
};


